// Hotfix user sidebar · Admin shortcuts cluster · V12 Achromatic Strict.
// -----------------------------------------------------------------------------
// Replica additive del gruppo `admin` di menuGroups.js (14 item) dentro il
// V12_USER_NAV_MINIMAL della dashboard V12 (/app/dashboard).
//
// Perché: menuGroups.js serve la dashboard LEGACY (Sidebar.jsx classico ·
// header dropdown). La dashboard V12 nuova usa invece V12UserSidebar.jsx che
// legge V12_USER_NAV_MINIMAL. L'utente admin/super_admin vuole le stesse
// scorciatoie admin disponibili su entrambe le shell.
//
// Visibilità · `allowFor: ["admin", "super_admin"]` → filtrato runtime da
// `filterNavByRole` in V12UserSidebar · completamente invisibile a role=user.
//
// Posizione · ultimo cluster del sidebar (dopo `community`), insertAfter.

const _ADMIN_ROLES = ["admin", "super_admin"];

export const V12_USER_NAV_ADMIN_SHORTCUTS_EXTENSIONS = {
    groupPatches: {},
    newGroups: [
        {
            insertAfter: "community",
            group: {
                id: "admin-shortcuts",
                label: "Admin",
                labelKey: "nav.cluster.admin_shortcuts",
                icon: "ShieldCheck",
                allowFor: _ADMIN_ROLES,
                items: [
                    { id: "min-adm-hub",            label: "Admin Hub",             to: "/admin/overview",                  implemented: true, icon: "LayoutDashboard", keywords: ["admin", "hub", "launcher"] },
                    { id: "min-adm-home",           label: "Admin Home",            to: "/admin",                           implemented: true, icon: "ShieldCheck",     keywords: ["admin", "home", "dashboard"] },
                    { id: "min-adm-users",          label: "Admin Users",           to: "/admin/users",                     implemented: true, icon: "Users",           keywords: ["admin", "users", "roles"] },
                    { id: "min-adm-audit-log",      label: "Admin Audit Log",       to: "/admin/audit-log",                 implemented: true, icon: "ScrollText",      keywords: ["admin", "audit", "log"] },
                    { id: "min-adm-observability",  label: "Admin Observability",   to: "/admin/observability",             implemented: true, icon: "Activity",        keywords: ["admin", "observability", "metrics"] },
                    { id: "min-adm-payments",       label: "Admin Payments",        to: "/admin/payments",                  implemented: true, icon: "Coins",           keywords: ["admin", "payments", "stripe"] },
                    { id: "min-adm-webhooks",       label: "Admin Webhooks",        to: "/admin/webhooks",                  implemented: true, icon: "Webhook",         keywords: ["admin", "webhooks", "events"] },
                    { id: "min-adm-marketplace-mod", label: "Admin Marketplace Mod", to: "/admin/marketplace/moderation",   implemented: true, icon: "ShoppingBag",     keywords: ["admin", "marketplace", "moderation"] },
                    { id: "min-adm-blog-engine",    label: "Admin Blog Engine",     to: "/admin/blog-engine/articles",      implemented: true, icon: "FileText",        keywords: ["admin", "blog", "engine", "articles"] },
                    { id: "min-adm-ai-engine",      label: "Admin AI Engine",       to: "/admin/ai-engine",                 implemented: true, icon: "Sparkles",        keywords: ["admin", "ai", "engine"] },
                    { id: "min-adm-crm-contacts",   label: "Admin CRM Contacts",    to: "/admin/crm/contacts",              implemented: true, icon: "Users",           keywords: ["admin", "crm", "contacts"] },
                    { id: "min-adm-outreach",       label: "Admin Outreach",        to: "/admin/outreach",                  implemented: true, icon: "Mail",            keywords: ["admin", "outreach", "campaigns"] },
                    { id: "min-adm-system-settings", label: "Admin System Settings", to: "/admin/system-settings",          implemented: true, icon: "Settings",        keywords: ["admin", "system", "settings"] },
                    { id: "min-adm-feature-flags", label: "Admin Feature Flags",   to: "/admin/feature-flags",             implemented: true, icon: "Flag",            keywords: ["admin", "feature", "flags"] },
                ],
            },
        },
    ],
};

/**
 * Merge V12 user nav MINIMAL + Admin shortcuts · pure function · idempotent.
 * Chain order: discovery → community → admin-shortcuts (ultimo).
 */
export function applyUserAdminShortcutsExtensions(baseGroups) {
    if (baseGroups.some((g) => g.id === "admin-shortcuts")) return baseGroups;
    const out = [];
    const pending = [...V12_USER_NAV_ADMIN_SHORTCUTS_EXTENSIONS.newGroups];
    for (const g of baseGroups) {
        out.push(g);
        for (let i = pending.length - 1; i >= 0; i--) {
            if (pending[i].insertAfter === g.id) {
                out.push(pending[i].group);
                pending.splice(i, 1);
            }
        }
    }
    if (pending.length > 0) {
        // eslint-disable-next-line no-console
        console.warn(
            "[V12 user nav] admin-shortcuts extensions con insertAfter non trovato:",
            pending.map((p) => p.group.id),
        );
        for (const p of pending) out.push(p.group);
    }
    return out;
}
